<template>
  <div :class="[imageClass, imageState]" :style="computedImage" :data-width="imageWidth" :data-height="imageHeight" :data-state="imageState">
    <div :class="[previewClass, imageState]" :style="computedPreview"></div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    imageClass: {
      type: String,
      required: false,
      default: ''
    },
    previewClass: {
      type: String,
      required: false,
      default: ''
    },
    imagePreview: {
      type: String,
      required: true
    },
    imageId: {
      type: String,
    },
    imageWidth: {
      type: String,
    },
    imageHeight: {
      type: String,
    },
    imageMode: {
      type: String,
    },
    backgroundSize: {
      type: String,
      required: false,
      default: 'cover'
    }
  },
  data() {
    return {
      imageWidth: 0,
      imageHeight: 0,
      imageState: 'loading',
      asyncImage: new Image()
    }
  },
  computed: {
    computedImage() {
      if (this.imageState === 'loaded') {
        return 'background-image: url(' + this.asyncImage.src + '); background-size: ' + this.backgroundSize
      }
      return '';
    },
    computedPreview() {
      return 'background-image: url(' + this.imagePreview + ')';
    }
  },
  methods: {
    getImage(id) {
      var url = '/api/imager.json?id='+ id;

      if (this.imageWidth) {
        url = url + '&width='+this.imageWidth;
      }
      if (this.imageHeight) {
        url = url + '&height='+this.imageHeight;
      }
      if (this.imageRatio) {
        url = url + '&ratio='+this.imageRatio;
      }
      if (this.imageMode) {
        url = url + '&type='+this.imageMode;
      }

      axios.get(url, { crossdomain: true })
      .then((response) => {
        this.imageSource = response.data.data[0].url;
        this.fetchImage();
      })
    },
    fetchImage() {
      this.asyncImage.onload = this.imageOnLoad
      this.asyncImage.onerror = this.imageOnError
      this.imageState = 'loading'
      this.asyncImage.src = this.imageSource
    },
    imageOnLoad(success) {
      this.imageState = 'loaded'
      this.imageWidth =  this.asyncImage.naturalWidth
      this.imageHeight = this.asyncImage.naturalHeight
    },
    imageOnError(error) {
      this.imageState = 'error'
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getImage(this.imageId)
    })
  },
  watch: {
    imageId: function() {
      this.imageState === 'loading'
      this.getImage(this.imageId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// image-loader-bg.vue?75b00edb